import PropTypes from 'prop-types'
import { objectAvailabilityPropType } from './object-availability-prop-type'

/**
 * @typedef {Object<Id, ObjectAvailability>} ObjectAvailabilities
 */
export const objectAvailabilitiesPropType = PropTypes.shape({
    objectId: PropTypes.arrayOf(objectAvailabilityPropType)
})
